/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface UserAuthorityDto
 */
export interface UserAuthorityDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof UserAuthorityDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserAuthorityDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserAuthorityDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof UserAuthorityDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof UserAuthorityDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof UserAuthorityDto
     */
    description: string;
}
